var premium_website_modal = function (e, message, event_type) {
  if (e !== undefined && e !== "event") {
    e.preventDefault();
  }

  $("#premiumWebsiteModal").modal("show");
};

export default premium_website_modal;
